var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { JsonTableMixin } from './qbo-jsontable.js';
let QboLogReader = class QboLogReader extends JsonTableMixin(LitElement) {
    constructor() {
        super(...arguments);
        this.endpoint = '/logging/logging/read';
        this.defaultHeaders = ['TimeStamp', 'LogLevel', 'EventId', 'Message', 'Category'];
    }
};
__decorate([
    property(),
    __metadata("design:type", String)
], QboLogReader.prototype, "endpoint", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboLogReader.prototype, "defaultHeaders", void 0);
QboLogReader = __decorate([
    customElement('qbo-logreader')
], QboLogReader);
export { QboLogReader };
//# sourceMappingURL=qbo-logreader.js.map